import snakeCase from 'lodash/snakeCase';

function format(str) {
  return snakeCase(str);
}

export function loggerTrack() {
  return (event) => {
    const domain = format(event.domain || '');
    const object = format(event.object || '');
    const verb = format(event.verb || '');

    try {
      /* eslint-disable no-console */
      console.log(
        `%c[EVENT] - ${domain}.${object}.${verb} -`,
        'color: #AA00FF',
        event
      );
      /* eslint-enable */
    } catch (e) {} // eslint-disable-line no-empty
  };
}
